export const PLATFORM_ADMIN_ROLES = Object.freeze(['admin', 'superadmin']);

export const canAccessRoles = (role, allowedRoles) => (
  !allowedRoles?.length || allowedRoles.includes(role)
);
